/**
 * Resolve the API base URL for axios and media links.
 *
 * Docker/nginx serves the SPA and proxies /api to the backend on the same
 * origin, so REACT_APP_API_BASE_URL="" must stay empty (not fall back to
 * localhost:8000, which is not exposed on the host).
 *
 * Local CRA dev (port 3000) still defaults to http://localhost:8000.
 */
export function getApiBaseUrl() {
  const fromEnv = process.env.REACT_APP_API_BASE_URL;
  if (fromEnv != null && fromEnv !== '') {
    return fromEnv.replace(/\/$/, '');
  }
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:8000';
  }
  return '';
}
